import { render } from "./AppEditor.vue?vue&type=template&id=72f2b507&ts=true"
import script from "./AppEditor.vue?vue&type=script&lang=ts"
export * from "./AppEditor.vue?vue&type=script&lang=ts"

import "./AppEditor.vue?vue&type=style&index=0&id=72f2b507&lang=css"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__